import { MapType } from '@/types';

export enum AMC_PLAN_TYPES {
  'VALUE' = 'VALUE',
  'SILVER' = 'SILVER',
  'GOLD' = 'GOLD',
  'PLATINUM' = 'PLATINUM',
  'COMP' = 'COMP',
}

export const AMC_NAME = 'Genuine AMC ·';
export const AMC_SERVICE_SESSION = 'amc_servie_session';
export const AMC_SERVICE_UPSELL_DATA = 'amc_servie_upsell_data';
export const AMC_STORIES_SHOWEN = 'amc_stories_shown';

export enum DEVICE_TECHNOLOGY {
  'UV' = 'UV',
  'RO' = 'RO',
}

export const AMC_PLAN_TYPE_NAMES: MapType = {
  VALUE: 'Base',
  SILVER: 'Silver',
  GOLD: 'Gold',
  PLATINUM: 'Platinum',
  COMP: 'Comprehensive',
};

export const PLAN_BORDER_MAP: MapType = {
  [AMC_PLAN_TYPES.GOLD]: 'border-amc-gold/20 bg-amc-gold-gradient',
  [AMC_PLAN_TYPES.VALUE]: 'border-amc-base/20',
  [AMC_PLAN_TYPES.SILVER]: 'border-amc-silver/20 bg-amc-silver-gradient',
  [AMC_PLAN_TYPES.PLATINUM]: 'border-amc-platinum/20 bg-amc-platinum-gradient',
};

export const PLAN_BACKGROUND_MAP: MapType = {
  [AMC_PLAN_TYPES.VALUE]: '#CFCFCF',
  [AMC_PLAN_TYPES.SILVER]: 'linear-gradient(180deg, #768A9D 0%, rgba(118, 138, 157, 0.3) 100%)',
  [AMC_PLAN_TYPES.GOLD]: 'linear-gradient(180deg, #B29577 0%, rgba(178, 149, 119, 0.36) 100%)',
  [AMC_PLAN_TYPES.PLATINUM]: 'linear-gradient(0deg, #EBE5D3 0%, #373022 100%)',
};

export const PLAN_CART_ITEM_BACKGROUND_MAP: MapType = {
  [AMC_PLAN_TYPES.VALUE]: '#CFCFCF',
  [AMC_PLAN_TYPES.SILVER]: 'linear-gradient(180deg, #768A9D 0%, rgba(118, 138, 157, 0.3) 100%)',
  [AMC_PLAN_TYPES.GOLD]: 'linear-gradient(180deg, #B29577 0%, rgba(178, 149, 119, 0.36) 100%)',
  [AMC_PLAN_TYPES.PLATINUM]: 'linear-gradient(0deg, #EBE5D3 0%, #373022 100%)',
};

export const PLAN_BOX_SHADOW = '0px 4.326px 25.957px 0px rgba(0, 0, 0, 0.15)';
export const DEFAULT_DEVICE_FAMILY_NAME = 'default';

export const LOCATION_PERMISSION_ERRORS = {
  PERMISSION_DENIED: 'User denied the request for Geolocation.',
  POSITION_UNAVAILABLE: 'Location information is unavailable.',
  TIMEOUT: 'The request to get user location timed out.',
  BROWSER_NO_SUPPORT: 'Geolocation is not supported by this browser.',
  DEFAULT: 'An error occurred.',
};

export const FETCHING_CURRENT_LOCATION = 'Fetching Current Location....';
export const USER_LOCATION_PERMISSION_DENIED =
  'Looks like your geolocation permissions are blocked. Please, provide geolocation access in your browser settings.';
